module.exports = __webpack_public_path__ + "img/kjjh_gallery1.97eba5f5.jpg";